module.exports = "/365FarmNet/dist/allItemsPopup.1db51512a590a1b21a169830b8e6da49.html";